import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from '../shared.module';

@Component({
  standalone: true,
  selector: 'icu-loading-icon-button',
  templateUrl: 'loading-icon-button.component.html',
  styleUrls: ['loading-icon-button.component.css'],
  imports: [SharedModule, MatIconModule, MatProgressBarModule]
})

export class LoadingIconButtonComponent implements OnChanges {
  @Input() icon: string;
  @Input() loading?: boolean;
  @Input() disabled?: boolean;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() useProgressBar = true;
  @Output() clicked = new EventEmitter<void>();

  public rotating = false;

  onClicked(ev: Event): void {
    ev.stopPropagation();
    if (!this.loading) {
      this.clicked.emit();
    }
  }

  ngOnChanges(): void {
    if (this.loading && !this.rotating && !this.useProgressBar) {
      this.rotating = true;
      setTimeout(() => {
        this.rotating = false;
      }, 1000);
    }
  }

}